import { render, staticRenderFns } from "./IndexWork.vue?vue&type=template&id=4bac0f17&scoped=true&"
import script from "./IndexWork.vue?vue&type=script&lang=js&"
export * from "./IndexWork.vue?vue&type=script&lang=js&"
import style0 from "./IndexWork.vue?vue&type=style&index=0&id=4bac0f17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac0f17",
  null
  
)

export default component.exports